import classNames from "classnames";
import React, { useEffect, useRef } from "react";

import icons from "../../../utils/svgProvider";

interface SuccesButtonPropsI {
	bought: string;
	label: string;
	className?: string;
	onClickHandler: () => void;
	tabIndex?: number | undefined;
}

const SuccessButton = (props: SuccesButtonPropsI) => {
	const buttonRef = useRef<HTMLButtonElement>(null);

	useEffect(() => {
		if (buttonRef.current) {
			buttonRef.current.focus();
		}
	}, []);

	const { bought, label, className = "primary", onClickHandler, tabIndex } = props;

	return (
		<button
			aria-label={bought}
			className={classNames("btn-medium addtocart-buy_button background-transition added-to-cart addtocart-added", className)}
			ref={buttonRef}
			onClick={onClickHandler}
			tabIndex={tabIndex}
			type="button"
		>
			<span>{icons.checkmarkButton}</span>
			<span
				className="checkmark__label--success"
				dangerouslySetInnerHTML={{ __html: label }}
			></span>
		</button>
	);
};

export default SuccessButton;
